import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";

export default function AppInfo(props: {
  logo: string;
  name: string;
  hasDevices: boolean;
  onIconClick: () => void;
}) {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();

  const theme = useTheme();

  const styles: {
    logo: React.CSSProperties;
  } = {
    logo: {
      height: 120,
      width: 120,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 20,
    },
  };

  return (
    <Grid2
      container
      flexDirection={isSmallLayout || isMediumLayout ? "column" : "row"}
    >
      <Grid2 xs display="flex" justifyContent="center" alignItems="center">
        <img src={props.logo} style={styles.logo} alt="logo" />
      </Grid2>
      <Grid2
        xs
        display="flex"
        justifyContent={
          isSmallLayout || isMediumLayout ? "center" : "flex-start"
        }
        alignItems="center"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            paddingTop: isSmallLayout || isMediumLayout ? 2 : 0,
            paddingBottom: isSmallLayout || isMediumLayout ? 2 : 0,
          }}
        >
          <h3
            style={{
              color: theme.textColor,
            }}
          >
            {props.name}
          </h3>
          {props.hasDevices && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent:
                  isSmallLayout || isMediumLayout ? "center" : "flex-start",
                textAlign: "center",
                fontSize: "10px",
                color: theme.detail,
                alignItems: "center",
              }}
            >
              <IconButton
                aria-label="info"
                onClick={() => props.onIconClick()}
                sx={{ alignItems: "center", color: theme.infoButton }}
              >
                <InfoIcon />
              </IconButton>
              {"supported devices"}
            </div>
          )}
        </div>
      </Grid2>
    </Grid2>
  );
}
